import { render, staticRenderFns } from "./ClientContactSelection.vue?vue&type=template&id=9b049fb2"
import script from "./ClientContactSelection.vue?vue&type=script&lang=js"
export * from "./ClientContactSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports